import styled from 'styled-components';

export const StyledNotificationActions = styled.div.attrs({
  className: 'notifications__actions',
})`
  display: flex;
`;
